export default "__VITE_ASSET__e262193a__"